import { Flex, FormTextarea, FormTextField } from '@shared/components';

export default function CreateAnnouncementFormField() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
      })}
    >
      <FormTextarea
        name='title'
        label='หัวข้อประกาศ'
        placeholder='ระบุหัวข้อข่าว/ประกาศ'
        required
        minRows={2}
      />
      <FormTextField
        name='referenceLink'
        label='แนบลิงก์อ้างอิง'
        placeholder='เช่น https://www.set.or.th/...'
      />
    </Flex>
  );
}
